export default "__VITE_ASSET__06cfdbc2__"